// Size Chart Modal Handler
class SizeChartModal {
  constructor() {
    this.modal = document.querySelector('[data-size-chart-modal]');
    if (!this.modal) return;

    // Move modal to document.body to escape parent transforms
    // (parent has CSS transform which breaks position:fixed)
    document.body.appendChild(this.modal);

    this.triggers = document.querySelectorAll('[data-size-chart-trigger]');
    this.closeButtons = this.modal.querySelectorAll('[data-size-chart-close]');

    this.init();
  }

  init() {
    this.triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.open();
      }.bind(this));
    }.bind(this));

    this.closeButtons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.close();
      }.bind(this));
    }.bind(this));

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && this.modal.classList.contains('active')) {
        this.close();
      }
    }.bind(this));
  }

  open() {
    this.scrollPosition = window.pageYOffset;
    this.modal.classList.add('active');
    document.body.classList.add('size-chart-modal-open');
    document.body.style.top = '-' + this.scrollPosition + 'px';
  }

  close() {
    this.modal.classList.remove('active');
    document.body.classList.remove('size-chart-modal-open');
    document.body.style.top = '';
    if (this.scrollPosition !== undefined) {
      window.scrollTo(0, this.scrollPosition);
    }
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    new SizeChartModal();
  });
} else {
  new SizeChartModal();
}
